import { date } from "yup";

import {
  BAPTISM,
  BAPTISM_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  CONFIRMATION,
  CONFIRMATION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  DEATH_REGISTER,
  DEATH_REGISTER_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  FIRST_COMMUNION,
  FIRST_COMMUNION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  FIRST_RECONCILIATION,
  FIRST_RECONCILIATION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  HOLY_ORDERS,
  HOLY_ORDERS_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  MARRIAGE,
  MARRIAGE_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
} from "./constants";

export const baptismConfig = {
  display: "Baptism",
  icon: "water fas",
  defaultFieldTypeInstanceMapping: BAPTISM_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  fields: {
    date: {
      display: "Date of Baptism",
      name: "BaptismDate",
    },
    location: {
      display: "Location",
      name: "BaptismLocation",
    },
    address: {
      display: "Address",
      name: "BaptismAddress",
    },
    celebrant: {
      display: "Celebrant",
      name: "BaptismCelebrant",
    },
    godparents: {
      display: "Godparents",
      name: "BaptismGodparents",
    },
    witnesses: {
      display: "Witnesses",
      name: "BaptismWitnesses",
    },
    certificate: {
      display: "Baptism Certificate",
      name: "BaptismCertificate",
    },
    notes: {
      display: "Notes",
      name: "BaptismNotes",
    },
    recordBook: {
      display: "Record Book",
      name: "BaptismRecordBook",
    },
    recordBookPage: {
      display: "Page",
      name: "BaptismRecordBookPage",
    },
    recordBookEntry: {
      display: "Entry",
      name: "BaptismRecordBookEntry",
    },
    nonCatholic: {
      display: "Non-Catholic Baptism?",
      name: "BaptismNonCatholic",
    },
    receivedThroughRCIAOCIA: {
      display: "Received through RCIA/OCIA?",
      name: "BaptismReceivedThroughRCIAOCIA",
    },
    atCurrentChurch: {
      display: "At Current Church?",
      name: "BaptismAtCurrentChurch",
    },
  },
};

export const confirmationConfig = {
  display: "Confirmation",
  icon: "dove fas",
  defaultFieldTypeInstanceMapping:
    CONFIRMATION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  fields: {
    date: {
      display: "Date of Confirmation",
      name: "ConfirmationDate",
    },
    location: {
      display: "Location",
      name: "ConfirmationLocation",
    },
    address: {
      display: "Address",
      name: "ConfirmationAddress",
    },
    celebrant: {
      display: "Celebrant",
      name: "ConfirmationCelebrant",
    },
    sponsor: {
      display: "Sponsor",
      name: "ConfirmationSponsor",
    },
    name: {
      display: "Confirmation Name",
      name: "ConfirmationName",
    },
    certificate: {
      display: "Confirmation Certificate",
      name: "ConfirmationCertificate",
    },
    notes: {
      display: "Notes",
      name: "ConfirmationNotes",
    },
    recordBook: {
      display: "Record Book",
      name: "ConfirmationRecordBook",
    },
    recordBookPage: {
      display: "Page",
      name: "ConfirmationRecordBookPage",
    },
    recordBookEntry: {
      display: "Entry",
      name: "ConfirmationRecordBookEntry",
    },
    receivedThroughRCIAOCIA: {
      display: "Received through RCIA/OCIA?",
      name: "ConfirmationReceivedThroughRCIAOCIA",
    },
    atCurrentChurch: {
      display: "At Current Church?",
      name: "ConfirmationAtCurrentChurch",
    },
  },
};

export const firstCommunionConfig = {
  display: "First Communion",
  icon: "wine-glass fas",
  defaultFieldTypeInstanceMapping:
    FIRST_COMMUNION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  fields: {
    date: {
      display: "Date of First Communion",
      name: "FirstCommunionDate",
    },
    location: {
      display: "Location",
      name: "FirstCommunionLocation",
    },
    address: {
      display: "Address",
      name: "FirstCommunionAddress",
    },
    celebrant: {
      display: "Celebrant",
      name: "FirstCommunionCelebrant",
    },
    certificate: {
      display: "First Communion Certificate",
      name: "FirstCommunionCertificate",
    },
    notes: {
      display: "Notes",
      name: "FirstCommunionNotes",
    },
    recordBook: {
      display: "Record Book",
      name: "FirstCommunionRecordBook",
    },
    recordBookPage: {
      display: "Page",
      name: "FirstCommunionRecordBookPage",
    },
    recordBookEntry: {
      display: "Entry",
      name: "FirstCommunionRecordBookEntry",
    },
    receivedThroughRCIAOCIA: {
      display: "Received through RCIA/OCIA?",
      name: "FirstCommunionReceivedThroughRCIAOCIA",
    },
    atCurrentChurch: {
      display: "At Current Church?",
      name: "FirstCommunionAtCurrentChurch",
    },
  },
};

export const firstReconciliationConfig = {
  display: "First Reconciliation",
  icon: "praying-hands fas",
  defaultFieldTypeInstanceMapping:
    FIRST_RECONCILIATION_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  fields: {
    date: {
      display: "Date of First Reconciliation",
      name: "FirstReconciliationDate",
    },
    location: {
      display: "Location",
      name: "FirstReconciliationLocation",
    },
    address: {
      display: "Address",
      name: "FirstReconciliationAddress",
    },
    celebrant: {
      display: "Celebrant",
      name: "FirstReconciliationCelebrant",
    },
    certificate: {
      display: "First Reconciliation Certificate",
      name: "FirstReconciliationCertificate",
    },
    notes: {
      display: "Notes",
      name: "FirstReconciliationNotes",
    },
    recordBook: {
      display: "Record Book",
      name: "FirstReconciliationRecordBook",
    },
    recordBookPage: {
      display: "Page",
      name: "FirstReconciliationRecordBookPage",
    },
    recordBookEntry: {
      display: "Entry",
      name: "FirstReconciliationRecordBookEntry",
    },
    receivedThroughRCIAOCIA: {
      display: "Received through RCIA/OCIA?",
      name: "FirstReconciliationReceivedThroughRCIAOCIA",
    },
    atCurrentChurch: {
      display: "At Current Church?",
      name: "FirstReconciliationAtCurrentChurch",
    },
  },
};

export const holyOrdersConfig = {
  display: "Holy Orders",
  icon: "bible fas",
  defaultFieldTypeInstanceMapping:
    HOLY_ORDERS_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  fields: {
    date: {
      display: "Date of Ordination",
      name: "HolyOrdersDate",
    },
    location: {
      display: "Location",
      name: "HolyOrdersLocation",
    },
    address: {
      display: "Address",
      name: "HolyOrdersAddress",
    },
    celebrant: {
      display: "Celebrant",
      name: "HolyOrdersCelebrant",
    },
    certificate: {
      display: "Holy Orders Certificate",
      name: "HolyOrdersCertificate",
    },
    notes: {
      display: "Notes",
      name: "HolyOrdersNotes",
    },
    recordBook: {
      display: "Record Book",
      name: "HolyOrdersRecordBook",
    },
    recordBookPage: {
      display: "Page",
      name: "HolyOrdersRecordBookPage",
    },
    recordBookEntry: {
      display: "Entry",
      name: "HolyOrdersRecordBookEntry",
    },
    atCurrentChurch: {
      display: "At Current Church?",
      name: "HolyOrdersAtCurrentChurch",
    },
  },
};

export const marriageConfig = {
  display: "Marriage",
  icon: "rings-wedding fas",
  defaultFieldTypeInstanceMapping: MARRIAGE_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  fields: {
    date: {
      display: "Date of Marriage",
      name: "MarriageDate",
    },
    location: {
      display: "Location",
      name: "MarriageLocation",
    },
    address: {
      display: "Address",
      name: "MarriageAddress",
    },
    celebrant: {
      display: "Celebrant",
      name: "MarriageCelebrant",
    },
    spouse: {
      display: "Spouse",
      name: "MarriageSpouse",
    },
    witnesses: {
      display: "Witnesses",
      name: "MarriageWitnesses",
    },
    certificate: {
      display: "Marriage Certificate",
      name: "MarriageCertificate",
    },
    notes: {
      display: "Notes",
      name: "MarriageNotes",
    },
    recordBook: {
      display: "Record Book",
      name: "MarriageRecordBook",
    },
    recordBookPage: {
      display: "Page",
      name: "MarriageRecordBookPage",
    },
    recordBookEntry: {
      display: "Entry",
      name: "MarriageRecordBookEntry",
    },
    atCurrentChurch: {
      display: "At Current Church?",
      name: "MarriageAtCurrentChurch",
    },
  },
};

export const deathRegisterConfig = {
  display: "Funeral & Death Register",
  defaultFieldTypeInstanceMapping:
    DEATH_REGISTER_DEFAULT_FIELD_TYPE_INSTANCE_MAPPING,
  fields: {
    date: {
      display: "Date of Death",
      name: "DeathRegisterDate",
    },
    location: {
      display: "Location of Funeral",
      name: "DeathRegisterLocation",
    },
    address: {
      display: "Address",
      name: "DeathRegisterAddress",
    },
    celebrant: {
      display: "Celebrant",
      name: "DeathRegisterCelebrant",
    },
    dateOfBurial: {
      display: "Date of Burial",
      name: "DeathRegisterDateOfBurial",
    },
    cremation: {
      display: "Cremation?",
      name: "DeathRegisterCremation",
    },
    notes: {
      display: "Notes",
      name: "DeathRegisterNotes",
    },
    recordBook: {
      display: "Record Book",
      name: "DeathRegisterRecordBook",
    },
    recordBookPage: {
      display: "Page",
      name: "DeathRegisterRecordBookPage",
    },
    recordBookEntry: {
      display: "Entry",
      name: "DeathRegisterRecordBookEntry",
    },
    atCurrentChurch: {
      display: "Funeral at Current Church?",
      name: "DeathRegisterAtCurrentChurch",
    },
  },
};
export const sacramentsConfig = {
  [BAPTISM]: baptismConfig,
  [CONFIRMATION]: confirmationConfig,
  [FIRST_COMMUNION]: firstCommunionConfig,
  [FIRST_RECONCILIATION]: firstReconciliationConfig,
  [HOLY_ORDERS]: holyOrdersConfig,
  [MARRIAGE]: marriageConfig,
  [DEATH_REGISTER]: deathRegisterConfig,
};
